module.exports = __webpack_public_path__ + "static/media/Bronze.750d8902.svg";